<template>
    <div class="inner with-content">
        <div class="headline">
            <h1>{{ $t('user.settings.password.headline') }}</h1>
        </div>
        <div class="container change-password">
            <form>
                <div class="material-input">
                    <input type="password" name="current-password" v-model="currentPassword"
                           :placeholder="$t('user.settings.password.current')">
                    <!--<p class=""><label for="">Current password</label></p>-->
                </div>
                <div class="material-input">
                    <input type="password" name="new-password" v-model="password"
                           :placeholder="$t('user.settings.password.new')">
                    <!--<p class=""><label for="">New password</label></p>-->
                </div>
                <div class="material-input">
                    <input type="password" name="new-password-confirm" v-model="passwordConfirmation"
                           :placeholder="$t('user.settings.password.repeat')">
                    <!--<p class=""><label for="">Repeat new password</label></p>-->
                </div>
                <button type="submit" :disabled="!validateInput" class="purple" @click.prevent="changePassword">
                    {{ $t('user.settings.password.button') }}
                </button>
            </form>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
    data: () => ({
        currentPassword: '',
        password: '',
        passwordConfirmation: '',
    }),
    computed: {
        validateInput() {
            return this.currentPassword && this.password && (this.password === this.passwordConfirmation);
        },
        ...mapGetters([
            'getToken'
        ])
    },
    methods: {
        async changePassword() {

            await axios({
                method: 'POST',
                url: this.$root.apiUrl + 'api/password/update',
                cancelToken: window.AuthorizationCancelSource.token,
                data: {
                    current_password: this.currentPassword,
                    password: this.password,
                    password_confirmation: this.passwordConfirmation,
                }
            });

            this.$router.push('/user/settings');
        }
    }
}
</script>
<style></style>
